module.exports = __webpack_public_path__ + "static/media/home-road-dropoff-xlarge.10686d12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home-road-dropoff-xlarge.png
// module id = 1531
// module chunks = 27